import React from 'react';
import { useDataContext } from '../context/data';

export function BotStyleCustomization() {
  const context = useDataContext();
  if (!context.appState?.widgetData?.css) {
    return null;
  }

  return <style type="text/css">{context.appState?.widgetData?.css}</style>;
}
